const isPartialPersonalization = (personalizationKey) => (personalizationKey === 'partial');
const isFullPersonalization = (personalizationKey) => (personalizationKey === 'full');
const personalizationUtil = {
    isPartialPersonalization,
    isFullPersonalization,
};
export default personalizationUtil;
